import { CirclePhone } from 'components';
import { css, mq, styled } from 'mymoria-ui';
import { Col, Row, Icon } from 'mymoria-ui/components';
import { useScrollDirection } from 'mymoria-ui/hooks';
import React from 'react';

const StyledDesktopHeader = styled.div(
  ({ theme: { colors } }) => css`
    position: fixed;
    height: 4.75rem;
    top: 0.25rem;
    left: 0;
    right: 0;
    align-items: center;
    background: ${colors.white};
    box-shadow: 0 7px 10px -10px ${colors.black};
    z-index: 1000;
    justify-content: space-between;

    ${mq({
      display: ['none', 'none', 'flex'],
    })};
  `,
);

const CirclePhoneBox = styled(Row)`
  display: flex;
  align-items: center;
`;

const DesktopLogo = styled(Icon.MymoriaLogo)`
  transform: scale(0.9);
`;

const StyledCol = styled(Col)(
  ({ theme: { colors } }) => css`
    height: 100%;
    padding: 0;
    background-color: ${colors.primary};
  `,
);

const HeaderDesktop = () => {
  const { isTop } = useScrollDirection({ thresholdPixels: 80 });

  return (
    <StyledDesktopHeader className={isTop ? 'visible' : 'hidden'}>
      <DesktopLogo />
      <StyledCol>
        <CirclePhoneBox justifyContent="space-between" alignItems="center">
          <CirclePhone isTop={isTop} />
        </CirclePhoneBox>
      </StyledCol>
    </StyledDesktopHeader>
  );
};

export default HeaderDesktop;
